import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798M11 3.91c-3.9 0-7 3.03-7 6.843s3.1 6.843 7 6.843 7-3.03 7-6.843c0-3.812-3.1-6.843-7-6.843m0 11.731c-2.8 0-5-2.15-5-4.888s2.2-4.888 5-4.888 5 2.15 5 4.888-2.2 4.888-5 4.888m0-7.82c-1.7 0-3 1.27-3 2.932s1.3 2.933 3 2.933 3-1.271 3-2.933-1.3-2.933-3-2.933zm0 3.91c-.6 0-1-.391-1-.978 0-.586.4-.978 1-.978s1 .391 1 .978-.4.978-1 .978"
    }, null, -1)
  ]))]))
}
export default { render: render }